export const isFilterEqual = (a, b) => {
  const typeEqual = a.type === b.type;
  const valueEqual = a.value === b.value;
  const labelEqual = a.label === b.label;
  return typeEqual && valueEqual && labelEqual;
};

export const diffBetween = (oldArray, newArray) => {
  const delta = {
    added: [],
    deleted: [],
    changed: [],
  };

  const newKeys = new Set(newArray.keys());

  oldArray.forEach((oldValue, oldKey) => {
    newKeys.delete(oldKey);
    const newValue = newArray[oldKey];
    if (newValue === undefined) {
      delta.deleted.push({ key: oldKey, value: oldValue });
      // eslint-disable-next-line no-useless-return
      return;
      // eslint-disable-next-line
    } else if (!isFilterEqual(oldValue, newValue)) {
      delta.changed.push({ key: oldKey, oldValue, newValue });
    }
  });

  newKeys.forEach((newKey) => {
    delta.added.push({ key: newKey, value: newArray[newKey] });
  });

  return delta;
};
